export default __webpack_public_path__ + "static/media/avg-price-source.46178e19.png";